export const useFile = (src?: any, key: string = 'base') => {
  if (!src) return undefined;

  // If src is already a URL string (http(s) or data URI), pass it through
  if (typeof src === 'string') {
    if (
      src.startsWith('http://') ||
      src.startsWith('https://') ||
      src.startsWith('data:')
    ) {
      return src;
    }
    // If src looks like a direct Supabase public path, pass through
    if (src.includes('/storage/v1/object/public/')) {
      return src;
    }
  }

  // Supabase file object
  if (typeof src !== 'string' && 'filename' in src) {
    return `${process.env.NEXT_PUBLIC_SUPABASE_URL}/storage/v1/object/public/${src.bucket ?? 'uploads'}/${src.filename}`;
  }

  // Fallback: return undefined so callers can decide how to render
  return undefined;
};
